import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  invoiceList: [],
  invoice: null,
  count: 0,
  summary: null
};

const slice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
      // state.invoiceList = [];
      state.invoice = null;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET INVOICE LIST
    getInvoiceListSuccess(state, action) {
      state.isLoading = false;
      state.invoiceList = action.payload.data;
      state.count = action.payload.count;
      state.summary = action.payload.summary;
    },

    // GET INVOICE
    getInvoiceSuccess(state, action) {
      state.isLoading = false;
      state.invoice = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
// export const { onToggleFollow, deleteCustomer } = slice.actions;

// ----------------------------------------------------------------------

export function getInvoiceList(selectedCompanyId, serie, filterName, desde, hasta, page, rowsPerPage, number = '') {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/v1/${selectedCompanyId}/invoice/series/${serie}`, {
        params: {
          filterName,
          number,
          desde,
          hasta,
          page,
          rowsPerPage
        }
      });
      dispatch(slice.actions.getInvoiceListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInvoice(selectedCompanyId, serie, number) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/v1/${selectedCompanyId}/invoice/series/${serie}/${number}`);
      dispatch(slice.actions.getInvoiceSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateInvoiceList(invoiceList) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.getInvoiceListSuccess(invoiceList));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
